/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ d: NonNullable<unknown> }} Valves_Demand_ValueInputs */



/**
* | output |
* | --- |
* | "- Th. head in demand: {d}" |
*
* @param {Valves_Demand_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valves_demand_value = /** @type {((inputs: Valves_Demand_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valves_Demand_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`- Th. head in demand: ${i?.d}`)
	return /** @type {LocalizedString} */ (`- Tête th. en demande: ${i?.d}`)
});